import React, { useState } from 'react';
import { MailboxTableSC, TableSC } from './mailbox-table.styled';
import Button from '../../ui/button';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import useWindowSize from '../../../utils/screen-size';
import WishmakerModal from '../../ui/modal/modal';
import DetailModal from '../detail-modal';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { EmptySC } from '../investor-mailbox-content.styled';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { Pagination } from '../../ui';
import useInlinePagination from '../../../utils/hooks/useInlinePagination';
import InlineLoading from '../../ui/inline-loading';

const MailboxTable = ({ messages, type, getMailboxAll, loading }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;
  const [isDetailModalOpened, setDetailModalOpened] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  React.useEffect(() => {
    getMailboxAll();
  }, [getMailboxAll]);

  const {
    slicedData,
    paginationConfig,
    onChange: handlePaginationChange,
    onPageSizeChange,
  } = useInlinePagination(messages);

  const onSelectDetail = (messageId) => {
    setSelectedDetail(messageId);
    setDetailModalOpened(true);
  };

  if (messages.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          {loading ? (
            <InlineLoading />
          ) : (
            <SmallText className="black-transparent bold">
              <FormattedMessage
                id="mailbox_emails_empty"
                defaultMessage={dlt['mailbox_emails_empty']}
              />
            </SmallText>
          )}
        </div>
      </EmptySC>
    );
  }

  return (
    <>
      <WishmakerModal
        isOpened={isDetailModalOpened}
        onClose={() => setDetailModalOpened(false)}
        className="sm"
        withCross
      >
        <DetailModal selectedDetail={selectedDetail} type={type} />
      </WishmakerModal>
      <MailboxTableSC>
        <TableSC>
          <tbody>
            {messages ? (
              <>
                {slicedData.map((message) => {
                  return (
                    <tr key={message.id}>
                      <td>
                        <div className="top-wrap">
                          <span>{message.subject ? message.subject : ''}</span>
                          <BodyText className="black-transparent-lighter">
                            <Moment format="DD. MMMM YYYY">{message.created_at}</Moment>
                          </BodyText>
                          {isTablet ? (
                            <BodyText className="black-transparent-lighter italic">
                              <FormattedMessage
                                id="mailbox_sent_through"
                                defaultMessage={dlt['mailbox_sent_through']}
                              />{' '}
                              "{message.type === 'sms' ? 'SMS' : 'Email'}"
                            </BodyText>
                          ) : null}
                        </div>
                        <div className="body-wrap">
                          <BodyText className="black-transparent">
                            <FormattedHTMLMessage
                              id="mailbox_short_message"
                              defaultMessage={message.short_message}
                            />
                          </BodyText>
                          {isTablet ? null : (
                            <BodyText className="black-transparent-lighter italic">
                              <FormattedMessage
                                id="mailbox_sent_through"
                                defaultMessage={dlt['mailbox_sent_through']}
                              />{' '}
                              "{message.type === 'sms' ? 'SMS' : 'Email'}"
                            </BodyText>
                          )}
                        </div>
                        {isTablet ? (
                          <div className="actions-wrap">
                            <div className="actions-wrap--item">
                              <BodyText className="bolder">
                                <FormattedMessage
                                  id="mailbox_table_sender"
                                  defaultMessage={dlt['mailbox_table_sender']}
                                />
                              </BodyText>
                              <br />
                              <BodyText>{message.sender}</BodyText>
                            </div>
                            <Button type="LINK" onClick={() => onSelectDetail(message.id)}>
                              <FormattedMessage
                                id="mailbox_table_detail_and_documents"
                                defaultMessage={dlt['mailbox_table_detail_and_documents']}
                              />
                            </Button>
                          </div>
                        ) : null}
                      </td>
                      {isTablet ? null : (
                        <td>
                          <div className="actions-wrap">
                            <div className="actions-wrap--item">
                              <BodyText className="bolder">
                                <FormattedMessage
                                  id="mailbox_table_sender"
                                  defaultMessage={dlt['mailbox_table_sender']}
                                />
                              </BodyText>
                              <br />
                              <BodyText>{message.sender}</BodyText>
                            </div>
                            <Button type="LINK" onClick={() => onSelectDetail(message.id)}>
                              <FormattedMessage
                                id="mailbox_table_detail_and_documents"
                                defaultMessage={dlt['mailbox_table_detail_and_documents']}
                              />
                            </Button>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </>
            ) : null}
          </tbody>
        </TableSC>
        {messages.length > 0 && (
          <div className="pagination-wrap">
            <Pagination
              pagination={paginationConfig}
              onChange={handlePaginationChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>
        )}
      </MailboxTableSC>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    messages: state.mailbox.all,
    loading: state.mailbox.allLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMailboxAll: ActionCreators.getMailboxAll,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MailboxTable);
